module.exports = __webpack_public_path__ + "img/medecine_sante.4a22a562.png";